/**
 * Parse a newline-separated (or comma/semicolon-separated) list of pasted SKUs
 * into a clean, de-duplicated array, preserving first-seen order.
 *
 * Used by the Sync Multi modal (PRD v1.8 §4.6.3.2-C) to turn an ops paste-blob
 * into `targets[]`. Pure + side-effect free so it can be unit-tested.
 */
export function parseSkuList(raw: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const token of raw.split(/[\n,;]+/)) {
    const sku = token.trim();
    if (!sku || seen.has(sku)) continue;
    seen.add(sku);
    out.push(sku);
  }
  return out;
}
